import { finalize, tap } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { AccountService } from 'src/app/shared/service/account.service';
import { ToastrService } from 'ngx-toastr';
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent,
  HttpResponse
} from '@angular/common/http';

@Injectable()
export class AuthorizationInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private toastrService: ToastrService,
    private accountService: AccountService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    
    return next.handle(req).pipe(
      tap(
        // response成功した場合
        (event: HttpEvent<any>) => {
        },
        error => {
          if (error.status === 401) {
            console.error('Authentication error:', error.status);
          }
          
          // より詳細なエラー情報を出力
          console.error('=== DETAILED ERROR ANALYSIS ===');
          console.error('Request details:');
          console.error('  - URL:', req.url);
          console.error('  - Method:', req.method);
          console.error('  - Headers:', JSON.stringify(req.headers.keys(), null, 2));
          console.error('  - Body:', JSON.stringify(req.body, null, 2));
          console.error('  - Params:', JSON.stringify(req.params, null, 2));
          
          console.error('Error details:');
          console.error('  - Status:', error.status);
          console.error('  - StatusText:', error.statusText);
          console.error('  - Error object:', JSON.stringify(error, null, 2));
          
          if (error.error) {
            console.error('  - Error.error type:', typeof error.error);
            console.error('  - Error.error keys:', Object.keys(error.error || {}));
            if (typeof error.error === 'string') {
              console.error('  - Error.error (string):', error.error);
            } else if (typeof error.error === 'object') {
              console.error('  - Error.error (object):', JSON.stringify(error.error, null, 2));
            }
          }
          
          // エラーの種類に応じた詳細情報
          if (error.status === 500) {
            console.error('=== 500 ERROR ANALYSIS ===');
            console.error('Server internal error detected');
            console.error('This might be related to:');
            console.error('  - Database query issues');
            console.error('  - Nil value comparisons');
            console.error('  - Missing data');
            console.error('  - Authentication issues');
            console.error('  - Permission issues');
          }
          
          console.error('=== END DETAILED ERROR ANALYSIS ===');
          console.error('=== END HTTP INTERCEPTOR ERROR ===');
          
          switch (error.status) {
            case 401: {
              const isEnabledV2Authentication = document.cookie
                .split(';')
                .some(item => item.trim().startsWith('v2_auth_data='));

              // v2ログアウトの場合（v2ログアウト時にv2認証用クッキーが削除される想定）
              if (!!localStorage.getItem('account') && !isEnabledV2Authentication) {
                this.toastrService.success('ログアウトしました')
              } else if (!!localStorage.getItem('account')) {
                  this.toastrService.error('ログインセッションが切れました');
              }
              this.accountService.clear();
              this.router.navigate(['/login']).then(
                () => {},
                onreject => {
                  setTimeout(() => {
                    window.location.reload();
                  }, 1000);
                }
              );
            }
          }
        }
      )
    );
  }
}
